import { dataThumbDown } from 'dls-icons-data'
import { createIcon } from '../common'

const IconThumbDown = /*#__PURE__*/createIcon(dataThumbDown)
export default IconThumbDown
